
import React, { useState, useEffect } from 'react';
import { Calendar } from 'lucide-react';
import { siteConfig } from '../../config/site';
import { useLanguage } from '../../App';

const FloatingBookingButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t, openBooking } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <button
      onClick={openBooking}
      className={`fixed bottom-8 right-8 z-[45] flex items-center gap-3 px-6 py-4 bg-black text-accent border border-accent shadow-[0_10px_40px_rgba(0,0,0,0.5)] transition-all duration-500 transform hover:scale-105 active:scale-95 group ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
      }`}
    >
      <div className="relative">
        <Calendar size={20} className="relative z-10" />
        <div className="absolute inset-0 bg-accent blur-md opacity-0 group-hover:opacity-40 transition-opacity"></div>
      </div>
      <span className="font-bold text-xs uppercase tracking-widest">{t.bookNow}</span>
    </button>
  );
};

export default FloatingBookingButton;
